import ServiceTemplate from '../ServiceTemplate';

const NewMortgage = () => {
  const serviceData = {
    title: 'משכנתא חדשה',
    description: 'ליווי מקצועי ומקיף בתהליך לקיחת המשכנתא הראשונה שלכם, כולל השוואת מסלולים והתאמה אישית לצרכים שלכם.',
    sections: [
      {
        title: 'איך התהליך עובד?',
        content: 'התהליך מתחיל בפגישת ייעוץ ראשונית בה נבין את הצרכים והיכולות שלכם. לאחר מכן, נבצע ניתוח מקיף של המצב הפיננסי, נבדוק את כל האפשרויות בשוק ונבנה עבורכם תמהיל משכנתא אופטימלי. נלווה אתכם בכל התהליך מול הבנק, כולל הכנת כל המסמכים הנדרשים.'
      },
      {
        title: 'למה כדאי לקחת ייעוץ משכנתא?',
        content: 'ייעוץ משכנתא מקצועי יכול לחסוך לכם מאות אלפי שקלים לאורך חיי המשכנתא. אנחנו מכירים את כל המסלולים, ההטבות והאפשרויות שהבנקים מציעים, ויודעים להתאים את התמהיל המושלם עבורכם.'
      }
    ],
    benefits: [
      'חיסכון משמעותי בעלויות המשכנתא',
      'ליווי אישי לאורך כל התהליך',
      'השוואת הצעות מכל הבנקים',
      'התאמה מדויקת ליכולות הפיננסיות שלכם',
      'הכנת כל המסמכים הנדרשים',
      'ייצוג מול הבנק וניהול המשא ומתן'
    ],
    faqs: [
      {
        question: 'מה ההבדל בין יועץ משכנתאות עצמאי ליועץ בנק?',
        answer: 'יועץ בנק מוגבל למוצרים ולתנאים של הבנק שלו בלבד, ובסופו של דבר הוא מייצג את האינטרסים של הבנק. לעומת זאת, כיועצת משכנתאות עצמאית, אני מייצגת אך ורק את האינטרסים שלכם. אני יכולה להשוות בין כל הבנקים, לנהל משא ומתן על התנאים ולהשיג עבורכם את ההצעה הטובה ביותר בשוק.'
      },
      {
        question: 'האם אפשר לקחת משכנתא ללא הון עצמי?',
        answer: 'על פי הוראות בנק ישראל, נדרש הון עצמי מינימלי של 25% מערך הנכס. עם זאת, ישנן דרכים יצירתיות להשלמת ההון העצמי, כמו מענקים ממשלתיים, הלוואות משלימות, או שילוב של מספר פתרונות. אני אעזור לכם למצוא את הפתרון המתאים ביותר עבורכם.'
      },
      {
        question: 'כמה זמן לוקח תהליך לקיחת משכנתא?',
        answer: 'תהליך לקיחת משכנתא אורך בממוצע בין שבועיים לחודש, תלוי במורכבות המקרה ובמהירות השגת המסמכים הנדרשים. כיועצת משכנתאות, אני מלווה אתכם בכל השלבים, מכינה את כל המסמכים מראש ומזרזת את התהליך ככל האפשר.'
      },
      {
        question: 'האם כדאי לקחת משכנתא במסלול קבוע או משתנה?',
        answer: 'אין תשובה אחת שמתאימה לכולם. ההחלטה תלויה במספר גורמים כמו: יכולת ההחזר החודשית, תחזית הריבית במשק, תקופת המשכנתא ועוד. אני אעזור לכם לבנות תמהיל מסלולים מאוזן שמתאים בדיוק לצרכים וליכולות שלכם.'
      },
      {
        question: 'למה לא לגשת ישירות לבנק?',
        answer: 'פנייה ישירה לבנק מגבילה אתכם להצעה אחת בלבד, ללא יכולת השוואה אמיתית ומשא ומתן. כיועצת עצמאית, אני מכירה את כל המסלולים בכל הבנקים, יכולה להשיג הצעות מתחרות ולנהל משא ומתן אפקטיבי שיחסוך לכם עשרות ומאות אלפי שקלים.'
      }
    ],
    whatsappMessage: 'שלום, אני מתעניין/ת בייעוץ למשכנתא חדשה ואשמח לשמוע פרטים נוספים.'
  };

  return <ServiceTemplate {...serviceData} />;
};

export default NewMortgage; 